import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=abc1b668&scoped=true&"
import script from "./Footer.js?vue&type=script&lang=js&"
export * from "./Footer.js?vue&type=script&lang=js&"
import style0 from "./Footer.scoped.scss?vue&type=style&index=0&id=abc1b668&lang=scss&scoped=true&"
import style1 from "./Footer.scss?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abc1b668",
  null
  
)

export default component.exports